import { render, staticRenderFns } from "./on-service-dashboard.vue?vue&type=template&id=22039f84"
import script from "./on-service-dashboard.vue?vue&type=script&lang=js"
export * from "./on-service-dashboard.vue?vue&type=script&lang=js"
import style0 from "./on-service-dashboard.vue?vue&type=style&index=0&id=22039f84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports